/**
 * ?state= values the member page uses to pick which auth form to render
 */
enum AuthQueryStates {
  SIGNUP = 'registrera',
  FORGOT = 'glomt-losenord',
  WHATS_THIS = 'vad-ar-det-har',
}

/**
 * Query parameters the member and callback pages are linked with, from emails and from cognito
 */
enum AuthQueryParams {
  ACCESS_TOKEN = 'access_token',
  EMAIL = 'email',
  ERROR = 'error',
  ERROR_DESCRIPTION = 'error_description',
  LOGIN = 'login',
  LOGOUT = 'logout',
  RESET_PASSWORD_CODE = 'aterstall',
  STATE = 'state',
  VERIFICATION_CODE = 'verifieringskod',
}

const AUTH_LOADING_STATE = 'loading'

export {
  AUTH_LOADING_STATE,
  AuthQueryParams,
  AuthQueryStates,
}
